import "./index.scss";
import { HeaderLiteDataProps } from "components/HeaderNew/HeaderLite/types";
import { LiveInspectorData } from "types/types";
import HeaderTop from "components/HeaderNew/components/HeaderTop";
import LangSelect from "components/HeaderNew/components/LangSelect";
import React from "react";

export type HeaderLiteProps = {
  data: HeaderLiteDataProps;
  liveInspector?: LiveInspectorData;
};

const HeaderLite = ({ data, liveInspector }: HeaderLiteProps) => (
  <div className="header-lite" {...liveInspector?.header}>
    {!!data.menu.length && <HeaderTop {...data} />}
    <div className="header-lite__bottom">
      <div className="header-lite__container">
        <div className="header-lite__logo">{data.settings.logo.image}</div>
        <div className="header-lite__lang-select">
          <LangSelect hasBackground />
        </div>
      </div>
    </div>
  </div>
);

export default HeaderLite;
